<div class="container">
  <div class="col-12">
    <h5 class="nmbcol">{{ 'Sellers.Products.ExtraInfo' | translate }} </h5>
    <div class="cardbg-white">
      <div class="row">
        <div class="col col-lg-6 mb-3">
          <app-image [fieldObject]="controllers['subscriptionImg']" [fieldErrors]="formValidator.formErrors"
            [formControlRef]="convertControls(controllers['subscriptionImg'].fieldName)" [productType]="productTypeId"
            [isUpdate]="isUpdate"></app-image>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 ">
    <div class="cardbg-white my-3">
      <div class="row">
        <div [formGroup]="PackageForm">
          <div formArrayName="Packages">
            <div *ngFor="let package of PackageList.controls; let i = index"
              class="row justify-content-center align-items-center">
              <div class="col-md-3 mb-3" [formGroupName]="i">
                <app-text [fieldObject]="packageController['Package Name']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertPackageControls(i, 'Package Name')" [productType]="productTypeId"
                  [isUpdate]="isUpdate"></app-text>
              </div>
              <div class="col-md-3 mb-3" [formGroupName]="i">
                <app-number [fieldObject]="packageController['Package Price']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertPackageControls(i, 'Package Price')" [productType]="productTypeId"
                  [isUpdate]="isUpdate"></app-number>
              </div>
              <div class="col-md-3 mb-3" [formGroupName]="i">
                <app-select-list [fieldObject]="packageController['Duration']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertPackageControls(i, 'Duration')" [productType]="productTypeId"
                  [isUpdate]="isUpdate"></app-select-list>
              </div>
              <div class="col-md-3 d-flex align-items-center mb-3" [formGroupName]="i" id="period" >
                <app-number [fieldObject]="packageController['Period']" [fieldErrors]="formValidator.formErrors"
                  [formControlRef]="convertPackageControls(i, 'Period')" [productType]="productTypeId"
                  [isUpdate]="isUpdate" [ngClass]="{'period-input':PackageList.controls.length>1}"></app-number>
                <span class="removeItem text-danger" title="Delete" (click)="removePackage(i)"
                  *ngIf="PackageList.controls.length > 1"><i class="fa fa-trash" style="transform: scale(1.5)"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div>
        <button type="button" [disabled]='PackageList.invalid' class="btn btn-success w-100 py-1 add-item"
          (click)="addPackage()">
          {{ 'Sellers.Products.AddPackage' | translate }}
        </button>
      </div>
        <div *ngIf="noPackage==true" class="text-danger">
          {{ 'Sellers.Products.AddPackageWarning' | translate }}
        </div>
      </div>
    </div>
    <div class="cardbg-white my-3">
      <div class="row">
        <app-toggle [fieldObject]="controllers['is_buyer_info']" [fieldErrors]="formValidator.formErrors"
          [formControlRef]="convertControls(controllers['is_buyer_info'].fieldName)" [isUpdate]="isUpdate">
        </app-toggle>
      </div>
    </div>

  </div>
</div>
